import createAPI from '../axios'
//基础信息相关API

const scoreRegistrationSkillsTraining = {
    scoreRegistration: {
        initCombo: config => createAPI('/scoreRegistrationSkillsTraining/scoreRegistration/initCombo', 'post', config),
        queryList: config => createAPI('/scoreRegistrationSkillsTraining/scoreRegistration/queryList', 'post', config),
        drcjdj: config => createAPI('/scoreRegistrationSkillsTraining/scoreRegistration/drcjdj', 'post', config),
        batchExport: config => createAPI('/scoreRegistrationSkillsTraining/scoreRegistration/batchExport', 'post', config),
    }
};

export default scoreRegistrationSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/scoreRegistrationSkillsTraining.js